import { useEffect } from "react";

export const useScrollTo = (ref, dependency, behavior = "smooth") => {
  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: behavior });
    }
  }, dependency);
};
